import React from "react";

export const SectionRule = ({ label }) => (
  <div className="flex items-center gap-4" aria-hidden="true">
    <span className="flex-1 h-px bg-border" />
    {label && <span className="editorial-kicker">{label}</span>}
    <span className="flex-1 h-px bg-border" />
  </div>
);

export default SectionRule;
